var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.42922 3.43907C5.32403 3.43907 5.23875 3.51845 5.23875 3.61637V16.3823C5.23875 16.4803 5.32403 16.5596 5.42922 16.5596H14.5721C14.6773 16.5596 14.7626 16.4803 14.7626 16.3823V6.18468C14.7626 6.13766 14.7425 6.09256 14.7068 6.05931L11.9477 3.491C11.9119 3.45775 11.8635 3.43907 11.813 3.43907H5.42922ZM3.33398 3.61637C3.33398 2.53922 4.27205 1.66602 5.42922 1.66602H11.813C12.3687 1.66602 12.9016 1.8715 13.2945 2.23726L16.0536 4.80557C16.4466 5.17134 16.6673 5.66742 16.6673 6.18468V16.3823C16.6673 17.4595 15.7292 18.3327 14.5721 18.3327H5.42922C4.27205 18.3327 3.33398 17.4595 3.33398 16.3823V3.61637Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2387 11.0632C13.2387 11.5528 12.8123 11.9497 12.2863 11.9497H7.71484C7.18886 11.9497 6.76246 11.5528 6.76246 11.0632C6.76246 10.5735 7.18886 10.1766 7.71484 10.1766H12.2863C12.8123 10.1766 13.2387 10.5735 13.2387 11.0632Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2387 14.2547C13.2387 14.7443 12.8123 15.1413 12.2863 15.1413H7.71484C7.18886 15.1413 6.76246 14.7443 6.76246 14.2547C6.76246 13.7651 7.18886 13.3682 7.71484 13.3682H12.2863C12.8123 13.3682 13.2387 13.7651 13.2387 14.2547Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatementIcon);
export default __webpack_public_path__ + "static/media/statementIcon.30b16c9f90b0af125f081829cb6ce487.svg";
export { ForwardRef as ReactComponent };